/* src/app/features/aviso/aviso-listagem.component.scss */
#col-acoes {
  width: 8%;
}
.letra-miuda {
  font-size: 14px;
  font-style: italic;
  text-align: bottom;
}
#pointer :hover {
  cursor: pointer;
}
/*# sourceMappingURL=aviso-listagem.component.css.map */
